import InstitutionPage from 'system/pages/institution/list';
import TownHallsPage from 'system/pages/town-halls/list';
import ServicesPage from 'system/pages/services/list';
import QualificationsPage from 'system/pages/qualifications/list';
import OperatorsPage from 'system/pages/operators/list';
import HomePage from 'system/pages/home';
import { Nocp } from 'shell/utils/nocp';
import { SystemContainer } from 'system/pages/container';
import InstitutionNewPage from 'system/pages/institution/new';
import InstitutionEditPage from 'system/pages/institution/edit';
import InstitutionDetailPage from 'system/pages/institution/detail';
import PageInstitutionInitializer from 'system/pages/institution';
import PageTownHallsInitializer from 'system/pages/town-halls';
import PageServicesInitializer from 'system/pages/services';
import PageQualificationsInitializer from 'system/pages/qualifications';
import PageOperatorsInitializer from 'system/pages/operators';
import TownHallNewPage from 'system/pages/town-halls/new';
import TownHallEditPage from 'system/pages/town-halls/edit';
import TownHallDetailPage from 'system/pages/town-halls/detail';
import QualificationNewPage from 'system/pages/qualifications/new';
import QualificationEditPage from 'system/pages/qualifications/edit';
import QualificationDetailPage from 'system/pages/qualifications/detail';
import ServiceNewPage from 'system/pages/services/new';
import ServiceEditPage from 'system/pages/services/edit';
import ServiceDetailPage from 'system/pages/services/detail';
import OperatorNewPage from 'system/pages/operators/new';
import {
  OperatorEditPage,
  OperatorEditPageQualificationsDetail,
  OperatorEditPageQualificationsEdit,
  OperatorEditPageServiceEdit,
  OperatorEditPageServiceDetail,
} from 'system/pages/operators/edit';
import {
  OperatorDetailPage,
  OperatorDetailPageQualificationsEdit,
  OperatorDetailPageQualificationsDetail,
  OperatorDetailPageServiceDetail,
  OperatorDetailPageServiceEdit,
} from 'system/pages/operators/detail';
import PageGroupsInitializer from 'system/pages/groups';
import GroupNewPage from 'system/pages/groups/new';
import GroupEditPage from 'system/pages/groups/edit';
import GroupDetailPage from 'system/pages/groups/detail';
import GroupsPage from 'system/pages/groups/list';
import PageFunctions from 'system/pages/functions';
import FunctionsList from 'system/pages/functions/list';
import FunctionsDetail from 'system/pages/functions/detail';
import FunctionsNew from 'system/pages/functions/new';
import FunctionsEdit from 'system/pages/functions/edit';
import PageCirculationAreasInitializer from 'system/pages/toponymy/circulation-area';
import CirculationAreasPage from 'system/pages/toponymy/circulation-area/list';
import CirculationAreaEditPage from 'system/pages/toponymy/circulation-area/edit';
import CirculationAreaDetailPage from 'system/pages/toponymy/circulation-area/detail';
import PageProfiles from 'system/pages/profiles';
import ProfilesListPage from 'system/pages/profiles/list';
import PageFeatureAuthInitializer from 'system/pages/feature-auth';
import FeatureAuthList from 'system/pages/feature-auth/list';
import FeatureAuthDetail from 'system/pages/feature-auth/detail';
import FeatureAuthNew from 'system/pages/feature-auth/new';
import FeatureAuthEdit from 'system/pages/feature-auth/edit';
import ProfilesNewPage from 'system/pages/profiles/new';
import ProfilesEditPage from 'system/pages/profiles/edit';
// import FeatureAuthValueInitializer from 'system/pages/feature-auth-value';
// import FeatureAuthValueList from 'system/pages/feature-auth-value/list';
// import FeatureAuthValueListNew from 'system/pages/feature-auth-value/new';
// import FeatureAuthValueListEdit from 'system/pages/feature-auth-value/edit';
// import FeatureAuthValueListDetail from 'system/pages/feature-auth-value/detail';
import ProfilesDetailPage from 'system/pages/profiles/detail';
import {
  ConsulateAuthorization,
  ForeignStateAuthorization,
  GroupAuthorization,
  InstitutionAuthorization,
  MunicipalityAuthorization,
  OperatorAuthorization,
  ProfileAuthorization,
  ProvinceAuthorization,
  QualificationAuthorization,
  RegionAuthorization,
  ServiceAuthorization,
  SystemAuthorizations,
  TerritoryAuthorization,
  FunctionsAuthorization,
  TownHallAuthorization,
  FeatureAuthAuthorization,
  BatchManagementAuthorization,
  ProcessingJobAuthorization,
  ToponymyAuthorization,
  SearchPublishedEventsAuthorization,
  CertificateAnprAuthorization,
  EventRegistrationAuthorization,
  SearchErrorEventsAuthorization,
  TypeEventAuthorizations,
  TypeDestinationAuthorizations,
  SubscriberAuthorization,
  ManagementNonRecoverableErrorsAuthorization,
  NumeratorAuthorization,
  PecManagementAuthorization,
  //FeatureAuthValueAuthorization,
} from 'shell/authorizations/system';
import { NotFound } from 'shell/error/components/error-not-found';
import GeographicModule from 'system/geographic/router';
import { Outlet } from 'react-router';
import PageBatchManagement from 'system/pages/batch-management';
import BatchManagementList from 'system/pages/batch-management/list';
import BatchManagementDetail from 'system/pages/batch-management/detail';
import BatchManagementNew from 'system/pages/batch-management/new';
import BatchManagementEdit from 'system/pages/batch-management/edit';
import ProcessingJobList from 'system/pages/processing-job/list';
import ProcessingJobDetail from 'system/pages/processing-job/detail';
import PageCertificateAnprsInitializer from 'system/pages/certificates-anpr';
import CertificateAnprListPage from 'system/pages/certificates-anpr/list';
import CertificateAnprNewPage from 'system/pages/certificates-anpr/new';
import CertificatesAnprEditPage from 'system/pages/certificates-anpr/edit';
import CertificatesAnprDetailPage from 'system/pages/certificates-anpr/detail';
import PageEventRegistrationInitializer from 'system/pages/event-registration';
import EventRegistrationPage from 'system/pages/event-registration/list';
import EventSuscriberNewPage from 'system/pages/event-registration/new';
import EventRegistrationEditPage from 'system/pages/event-registration/edit';
import EventRegistrationDetailPage from 'system/pages/event-registration/detail/indext';
import PagePublishedEventsInitializer from 'system/pages/search-published-events';
import PublishedEventsListPage from 'system/pages/search-published-events/list';
import PublishedEventDetailPage from 'system/pages/search-published-events/detail';
import ConsumedEventDetailPage from 'system/pages/search-published-events/detail-consumed-event';
import PageEventsInErrorInitializer from 'system/pages/search-events-error';
import ErrorEventsListPage from 'system/pages/search-events-error/list';
import ErrorEventDetailPage from 'system/pages/search-events-error/detail';
import EventPageInitializer from 'system/pages/type-events';
import EventListPage from 'system/pages/type-events/list';
import TypesEventNewPage from 'system/pages/type-events/new';
import TypeEventDetailsPage from 'system/pages/type-events/details';
import TypesEventEditPage from 'system/pages/type-events/edit';
import TypeDestinationInitializer from 'system/pages/type-destination';
import TypeDestinationListPage from 'system/pages/type-destination/list';
import TypeDestinationNewPage from 'system/pages/type-destination/new';
import TypeDestinationDetailPage from 'system/pages/type-destination/details';
import TypeDestinationEditPage from 'system/pages/type-destination/edit';
import SubscriberInitializer from 'system/pages/subscriber';
import SubscriberListPage from 'system/pages/subscriber/list';
import SubscriberDetailPage from 'system/pages/subscriber/details';
import SubscriberEditPage from 'system/pages/subscriber/edit';
import SubscriberNewPage from 'system/pages/subscriber/new';
import GestioneBacthUploadFile from 'system/pages/batch-management/file-managment/upload';
import PageBatchDownloadFile from 'system/pages/batch-management/file-managment/download';
import GestioneBatchDownloadFile from 'system/pages/batch-management/file-managment/download/list';
import PageNonRecoverableErrorsInitializer from 'system/pages/management-non-recoverable-errors';
import NonRecoverableErrorsListPage from 'system/pages/management-non-recoverable-errors/list';
import NonRecoverableErrorDetailPage from 'system/pages/management-non-recoverable-errors/detail';
import PageBatchDownloadAnpr from 'system/pages/batch-management/file-managment/download-anpr';
import GestioneBatchDownloadAnprFile from 'system/pages/batch-management/file-managment/download-anpr/list';
import CirculationAreaNewPage from 'system/pages/toponymy/circulation-area/new';
import PagePecInitializer from 'system/pages/crud-pec';
import PecListPage from 'system/pages/crud-pec/list';
import PecDetailPage from 'system/pages/crud-pec/detail';
import PageNumerators from 'system/pages/numerators';
import NumeratorsListPage from 'system/pages/numerators/list';
import NumeratorsNewPage from 'system/pages/numerators/new';
import NumeratorsEditPage from 'system/pages/numerators/edit';
import NumeratorsDetailPage from 'system/pages/numerators/detail';
import TerritorialAreasPage from 'system/pages/toponymy/territorial-area/list';
import PageTerritorialAreasInitializer from 'system/pages/toponymy/territorial-area';

// TODO lista per Tabelle Amministratore
export const systemRoutes = [
  {
    path: '',
    element: <SystemContainer />,
    children: [
      {
        path: '',
        name: 'Sistema',
        children: [
          {
            path: '',
            element: <HomePage />,
            hidden: true,
          },
          {
            path: '/eventmanager',
            hidden: true,
            element: <Outlet />,
            children: [
              {
                path: '/tipievento',
                element: <EventPageInitializer />,
                name: 'Tipo Evento',
                authorizations: TypeEventAuthorizations,
                children: [
                  {
                    path: '',
                    element: <EventListPage />,
                  },
                  {
                    path: '/nuovo',
                    element: <TypesEventNewPage />,
                    authorizations: [SystemAuthorizations.TipoEventoAdd],
                  },
                  {
                    path: '/dettaglio/:id',
                    element: <TypeEventDetailsPage />,
                    authorizations: [SystemAuthorizations.TipoEventoQuery],
                  },
                  {
                    path: '/modifica/:id',
                    element: <TypesEventEditPage />,
                    authorizations: [SystemAuthorizations.TipoEventoUpdate],
                  },
                ],
              },
              {
                path: '/tipidestinazione',
                element: <TypeDestinationInitializer />,
                name: 'Tipo Destinatione',
                authorizations: TypeDestinationAuthorizations,
                children: [
                  {
                    path: '',
                    element: <TypeDestinationListPage />,
                  },
                  {
                    path: '/nuovo',
                    element: <TypeDestinationNewPage />,
                    authorizations: [SystemAuthorizations.TipoDestinazioneAdd],
                  },
                  {
                    path: '/dettaglio/:id',
                    element: <TypeDestinationDetailPage />,
                    authorizations: [SystemAuthorizations.TipoDestinazioneQuery],
                  },
                  {
                    path: '/modifica/:id',
                    element: <TypeDestinationEditPage />,
                    authorizations: [SystemAuthorizations.TipoDestinazioneUpdate],
                  },
                ],
              },
              {
                path: '/sottoscrittore',
                name: 'Sottoscrittore',
                element: <SubscriberInitializer />,
                authorizations: SubscriberAuthorization,
                children: [
                  {
                    path: '',
                    element: <SubscriberListPage />,
                  },
                  {
                    path: '/nuovo',
                    element: <SubscriberNewPage />,
                    authorizations: [SystemAuthorizations.SottoscrittoreAdd],
                  },
                  {
                    path: '/dettaglio/:id',
                    element: <SubscriberDetailPage />,
                    authorizations: [SystemAuthorizations.SottoscrittoreQuery],
                  },
                  {
                    path: '/dettaglio/:id',
                    element: <SubscriberDetailPage />,
                    authorizations: [SystemAuthorizations.SottoscrittoreQuery],
                  },
                  {
                    path: '/modifica/:id',
                    element: <SubscriberEditPage />,
                    authorizations: [SystemAuthorizations.SottoscrittoreUpdate],
                  },
                ],
              },
              {
                path: '/iscrizione-evento',
                element: <PageEventRegistrationInitializer />,
                name: 'Iscrizione Evento',
                authorizations: EventRegistrationAuthorization,
                children: [
                  {
                    path: '',
                    element: <EventRegistrationPage />,
                  },
                  {
                    path: '/nuovo',
                    element: <EventSuscriberNewPage />,
                    authorizations: [SystemAuthorizations.IscrizioneEventoAdd],
                  },
                  {
                    path: '/modifica/:codiceSottoscrittore/:codiceTipoDestinazione/:codiceTipoEvento/:progressivo',
                    element: <EventRegistrationEditPage />,
                    authorizations: [SystemAuthorizations.IscrizioneEventoUpdate],
                  },
                  {
                    path: '/dettaglio/:codiceSottoscrittore/:codiceTipoDestinazione/:codiceTipoEvento/:progressivo',
                    element: <EventRegistrationDetailPage />,
                    authorizations: [SystemAuthorizations.IscrizioneEventoQuery],
                  },
                ],
              },
              {
                path: '/ricerca-eventi-pubblicati',
                element: <PagePublishedEventsInitializer />,
                name: 'Ricerca Eventi Pubblicati',
                authorizations: SearchPublishedEventsAuthorization,
                children: [
                  {
                    path: '',
                    element: <PublishedEventsListPage />,
                  },
                  {
                    path: '/dettaglio-evento-pubblicato/:id',
                    element: <PublishedEventDetailPage />,
                    authorizations: [SystemAuthorizations.EventoQuery],
                  },
                  {
                    path: '/dettaglio-evento-pubblicato/:idPublished/dettaglio-consumazione/:id',
                    element: <ConsumedEventDetailPage />,
                    authorizations: [SystemAuthorizations.EventoQuery],
                  },
                ],
              },
              {
                path: '/ricerca-eventi-in-errore',
                element: <PageEventsInErrorInitializer />,
                name: 'Ricerca Eventi In Errore',
                authorizations: SearchErrorEventsAuthorization,
                children: [
                  {
                    path: '',
                    element: <ErrorEventsListPage />,
                  },
                  {
                    path: '/dettaglio-evento-in-errore/:id',
                    element: <ErrorEventDetailPage />,
                    authorizations: [SystemAuthorizations.EventoErrQuery],
                  },
                ],
              },
              {
                path: '/gestione-errori-non-recuperabili',
                element: <PageNonRecoverableErrorsInitializer />,
                name: 'Gestione errori non recuperabili',
                authorizations: ManagementNonRecoverableErrorsAuthorization,
                children: [
                  {
                    path: '',
                    element: <NonRecoverableErrorsListPage />,
                  },
                  {
                    path: '/dettaglio-errore-non-recuperabile/:id',
                    element: <NonRecoverableErrorDetailPage />,
                    authorizations: [SystemAuthorizations.ErrorQuery],
                  },
                ],
              },
            ],
          },
          {
            path: '/enti',
            element: <PageInstitutionInitializer />,
            name: 'Enti',
            abilitations: {
              sistema: ['1', '2'],
            },
            authorizations: InstitutionAuthorization,
            children: [
              {
                path: '',
                element: <InstitutionPage />,
              },
              {
                path: '/nuovo',
                element: <InstitutionNewPage />,
                authorizations: [SystemAuthorizations.EnteAdd],
              },
              {
                path: '/modifica/:id',
                element: <InstitutionEditPage />,
                authorizations: [SystemAuthorizations.EnteUpdate],
              },
              {
                path: '/dettaglio/:id',
                element: <InstitutionDetailPage />,
                authorizations: [SystemAuthorizations.EnteQuery],
              },
            ],
          },
          {
            path: '/municipi',
            element: <PageTownHallsInitializer />,
            name: 'Municipi',
            abilitations: {
              sistema: ['1', '2'],
            },
            authorizations: TownHallAuthorization,
            children: [
              {
                path: '',
                element: <TownHallsPage />,
              },
              {
                path: '/nuovo',
                element: <TownHallNewPage />,
                authorizations: [SystemAuthorizations.MunicipioAdd],
              },
              {
                path: '/modifica/:id',
                element: <TownHallEditPage />,
                authorizations: [SystemAuthorizations.MunicipioUpdate],
              },
              {
                path: '/dettaglio/:id',
                element: <TownHallDetailPage />,
                authorizations: [SystemAuthorizations.MunicipioQuery],
              },
            ],
          },
          {
            path: '/servizi',
            element: <PageServicesInitializer />,
            name: 'Servizi',
            abilitations: {
              sistema: ['1', '2'],
            },
            authorizations: ServiceAuthorization,
            children: [
              {
                path: '',
                element: <ServicesPage />,
              },
              {
                path: '/nuovo',
                element: <ServiceNewPage />,
                authorizations: [SystemAuthorizations.ServizioAdd],
              },
              {
                path: '/modifica/:id',
                element: <Outlet />,
                authorizations: [SystemAuthorizations.ServizioUpdate],
                children: [
                  {
                    path: '',
                    element: <ServiceEditPage />,
                  },
                  {
                    path: '/operatori/modifica/:idOperatore',
                    element: <OperatorEditPageServiceEdit />,
                  },
                  {
                    path: '/operatori/dettaglio/:idOperatore',
                    element: <OperatorDetailPageServiceEdit />,
                  },
                ],
              },
              {
                path: '/dettaglio/:id',
                element: <Outlet />,
                authorizations: [SystemAuthorizations.ServizioQuery],
                children: [
                  {
                    path: '',
                    element: <ServiceDetailPage />,
                  },
                  {
                    path: '/operatori/modifica/:idOperatore',
                    element: <OperatorEditPageServiceDetail />,
                  },
                  {
                    path: '/operatori/dettaglio/:idOperatore',
                    element: <OperatorDetailPageServiceDetail />,
                  },
                ],
              },
            ],
          },
          {
            path: '/qualifiche',
            element: <PageQualificationsInitializer />,
            name: 'Qualifiche',
            abilitations: {
              sistema: ['1', '2'],
            },
            authorizations: QualificationAuthorization,
            children: [
              {
                path: '',
                element: <QualificationsPage />,
              },
              {
                path: '/nuovo',
                element: <QualificationNewPage />,
                authorizations: [SystemAuthorizations.QualificaAdd],
              },
              {
                path: '/modifica/:id',
                element: <Outlet />,
                authorizations: [SystemAuthorizations.QualificaUpdate],
                children: [
                  {
                    path: '',
                    element: <QualificationEditPage />,
                  },
                  {
                    path: '/operatori/modifica/:idOperatore',
                    element: <OperatorEditPageQualificationsEdit />,
                    authorizations: [SystemAuthorizations.OperatoreUpdate],
                  },
                  {
                    path: '/operatori/dettaglio/:idOperatore',
                    element: <OperatorDetailPageQualificationsEdit />,
                    authorizations: [SystemAuthorizations.OperatoreQuery],
                  },
                ],
              },
              {
                path: '/dettaglio/:id',
                element: <Outlet />,
                authorizations: [SystemAuthorizations.QualificaQuery],
                children: [
                  {
                    path: '',
                    element: <QualificationDetailPage />,
                  },
                  {
                    path: '/operatori/modifica/:idOperatore',
                    element: <OperatorEditPageQualificationsDetail />,
                    authorizations: [SystemAuthorizations.OperatoreUpdate],
                  },
                  {
                    path: '/operatori/dettaglio/:idOperatore',
                    element: <OperatorDetailPageQualificationsDetail />,
                    authorizations: [SystemAuthorizations.OperatoreQuery],
                  },
                ],
              },
            ],
          },
          {
            path: '/operatori',
            element: <PageOperatorsInitializer />,
            name: 'Operatori',
            abilitations: {
              sistema: ['1', '2'],
            },
            authorizations: OperatorAuthorization,
            children: [
              {
                path: '',
                element: <OperatorsPage />,
              },
              {
                path: '/nuovo',
                element: <OperatorNewPage />,
                authorizations: [SystemAuthorizations.OperatoreAdd],
              },
              {
                path: '/modifica/:id',
                element: <OperatorEditPage />,
                authorizations: [SystemAuthorizations.OperatoreUpdate],
              },
              {
                path: '/dettaglio/:id',
                element: <OperatorDetailPage />,
                authorizations: [SystemAuthorizations.OperatoreQuery],
              },
            ],
          },
          {
            path: '/gruppi',
            element: <PageGroupsInitializer />,
            name: 'Gruppi',
            hidden: true,
            abilitations: {
              sistema: ['1', '2'],
            },
            authorizations: GroupAuthorization,
            children: [
              {
                path: '',
                element: <GroupsPage />,
              },
              {
                path: '/nuovo',
                element: <GroupNewPage />,
                authorizations: [SystemAuthorizations.GruppoAdd],
              },
              {
                path: '/modifica/:id',
                element: <GroupEditPage />,
                authorizations: [SystemAuthorizations.GruppoUpdate],
              },
              {
                path: '/dettaglio/:id',
                element: <GroupDetailPage />,
                authorizations: [SystemAuthorizations.GruppoQuery],
              },
            ],
          },
          {
            path: '/toponomastica',
            name: 'Toponomastica',
            abilitations: {
              gestioneToponomastica: ['1', '2'],
            },
            hidden: true,
            children: [
              {
                path: '/area-di-circolazione',
                element: <PageCirculationAreasInitializer />,
                authorizations: ToponymyAuthorization,
                hidden: true,
                children: [
                  {
                    path: '',
                    element: <CirculationAreasPage />,
                  },
                  {
                    path: '/nuovo',
                    element: <CirculationAreaNewPage />,
                  },
                  {
                    path: '/modifica/:id',
                    element: <CirculationAreaEditPage />,
                    authorizations: [SystemAuthorizations.AreacircolazioneUpdate],
                  },
                  {
                    path: '/dettaglio/:id',
                    element: <CirculationAreaDetailPage />,
                    authorizations: [SystemAuthorizations.AreacircolazioneQuery],
                  },
                ],
              },
              {
                path: '/ambiti-territoriali',
                element: <PageTerritorialAreasInitializer />,
                authorizations: ToponymyAuthorization,
                hidden: true,
                children: [
                  {
                    path: '',
                    element: <TerritorialAreasPage />,
                  },
                ],
              },
            ],
          },
          {
            path: '/funzioni',
            element: <PageFunctions />,
            name: 'Funzioni',
            abilitations: {
              sistema: ['1', '2'],
            },
            authorizations: FunctionsAuthorization,
            hidden: true,
            children: [
              {
                path: '',
                element: <FunctionsList />,
              },
              {
                path: '/dettaglio/:id',
                element: <FunctionsDetail />,
              },
              {
                path: '/nuovo',
                element: <FunctionsNew />,
              },
              {
                path: '/modifica/:id',
                element: <FunctionsEdit />,
              },
            ],
          },
          {
            path: '/gestione-batch',
            element: <PageBatchManagement />,
            hidden: true,
            name: 'Gestione Batch',
            authorizations: BatchManagementAuthorization,
            children: [
              {
                path: '',
                element: <BatchManagementList />,
              },
              {
                path: '/dettaglio/:id',
                element: <BatchManagementDetail />,
                authorizations: [SystemAuthorizations.BatchManagementQuery],
              },
              {
                path: '/nuovo',
                element: <BatchManagementNew />,
                authorizations: [SystemAuthorizations.BatchManagementAdd],
              },
              {
                path: '/modifica/:id',
                element: <BatchManagementEdit />,
                authorizations: [SystemAuthorizations.BatchManagementUpdate],
              },
              {
                path: '/gestione-file',
                name: 'Gestione File',
                element: <Outlet />,
                children: [
                  {
                    path: '/upload',
                    element: <GestioneBacthUploadFile />,
                  },
                  {
                    path: '/download',
                    element: <PageBatchDownloadFile />,
                    children: [
                      {
                        path: '',
                        element: <GestioneBatchDownloadFile />,
                      },
                    ],
                  },
                  {
                    path: '/download-anpr',
                    element: <PageBatchDownloadAnpr />,
                    children: [
                      {
                        path: '',
                        element: <GestioneBatchDownloadAnprFile />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: '/elaborazione-job',
            element: <PageBatchManagement />,
            hidden: true,
            name: 'Elaborazione Job',
            authorizations: ProcessingJobAuthorization,
            children: [
              {
                path: '',
                element: <ProcessingJobList />,
              },
              {
                path: '/dettaglio/:id',
                element: <ProcessingJobDetail />,
              },
            ],
          },
          {
            path: '/profili',
            element: <PageProfiles />,
            name: 'Profili',
            authorizations: ProfileAuthorization,
            abilitations: {
              sistema: ['1', '2'],
            },
            hidden: true,
            children: [
              {
                path: '',
                element: <ProfilesListPage />,
              },
              {
                path: '/nuovo',
                element: <ProfilesNewPage />,
                authorizations: [SystemAuthorizations.ProfiloAdd],
              },
              {
                path: '/modifica/:id',
                element: <ProfilesEditPage />,
                authorizations: [SystemAuthorizations.ProfiloUpdate],
              },
              {
                path: '/dettaglio/:id',
                element: <ProfilesDetailPage />,
                authorizations: [SystemAuthorizations.ProfiloQuery],
              },
            ],
          },
          // {
          //   path: '/feature-valore',
          //   element: <FeatureAuthValueInitializer />,
          //   name: 'Feature auth valore',
          //   hidden: true,
          //   authorizations: FeatureAuthValueAuthorization,
          //   children: [
          //     {
          //       path: '',
          //       element: <FeatureAuthValueList />,
          //     },
          //     {
          //       path: '/nuovo',
          //       element: <FeatureAuthValueListNew />,
          //       authorizations: [SystemAuthorizations.TipoFeatureValoreAdd],
          //     },
          //     {
          //       path: '/modifica/:id',
          //       element: <FeatureAuthValueListEdit />,
          //       authorizations: [SystemAuthorizations.TipoFeatureValoreUpdate],
          //     },
          //     {
          //       path: '/dettaglio/:id',
          //       element: <FeatureAuthValueListDetail />,
          //       authorizations: [SystemAuthorizations.TipoFeatureValoreQuery],
          //     },
          //   ],
          // },
          {
            path: '/feature-auth',
            element: <PageFeatureAuthInitializer />,
            name: 'Autorizzazioni',
            abilitations: {
              sistema: ['1', '2'],
            },
            authorizations: FeatureAuthAuthorization,
            hidden: true,
            children: [
              {
                path: '',
                element: <FeatureAuthList />,
              },
              {
                path: '/dettaglio/:id',
                element: <FeatureAuthDetail />,
                authorizations: [SystemAuthorizations.TipoFeatureAuthQuery],
              },
              {
                path: '/nuovo',
                element: <FeatureAuthNew />,
                authorizations: [SystemAuthorizations.TipoFeatureAuthAdd],
              },
              {
                path: '/modifica/:id',
                element: <FeatureAuthEdit />,
                authorizations: [SystemAuthorizations.TipoFeatureAuthUpdate],
              },
            ],
          },
          {
            path: '/numeratori',
            element: <PageNumerators />,
            name: 'Numeratori',
            authorizations: NumeratorAuthorization,
            hidden: true,
            children: [
              {
                path: '',
                element: <NumeratorsListPage />,
              },
              {
                path: '/nuovo',
                element: <NumeratorsNewPage />,
                authorizations: [SystemAuthorizations.NumeratoreAdd],
              },
              {
                path: '/modifica/:codiceEnte/:tipoRegistro/:annoDocumento',
                element: <NumeratorsEditPage />,
                authorizations: [SystemAuthorizations.NumeratoreUpdate],
              },
              {
                path: '/dettaglio/:codiceEnte/:tipoRegistro/:annoDocumento',
                element: <NumeratorsDetailPage />,
                authorizations: [SystemAuthorizations.NumeratoreQuery],
              },
            ],
          },
          {
            path: '/certificati-postazione',
            element: <PageCertificateAnprsInitializer />,
            name: 'Certificati Postazione Anpr',
            abilitations: {
              sistema: ['1', '2'],
            },
            authorizations: CertificateAnprAuthorization,
            children: [
              {
                path: '',
                element: <CertificateAnprListPage />,
              },
              {
                path: '/nuovo',
                element: <CertificateAnprNewPage />,
                authorizations: [SystemAuthorizations.CertificatoPostazioneAnprAdd],
              },
              {
                path: '/modifica/:id',
                element: <CertificatesAnprEditPage />,
                authorizations: [SystemAuthorizations.CertificatoPostazioneAnprUpdate],
              },
              {
                path: '/dettaglio/:id',
                element: <CertificatesAnprDetailPage />,
                authorizations: [SystemAuthorizations.CertificatoPostazioneAnprQuery],
              },
            ],
          },
          {
            path: '/pec',
            element: <PagePecInitializer />,
            name: 'Gestione PEC',
            authorizations: PecManagementAuthorization,
            children: [
              {
                path: '',
                element: <PecListPage />,
              },
              {
                path: '/dettaglio/:id',
                element: <PecDetailPage />,
                authorizations: [SystemAuthorizations.PecQuery],
              },
            ],
          },
          {
            path: '/geografiche/*',
            element: <GeographicModule />,
            abilitations: {
              gestioneGeografiche: ['1', '2'],
            },
            authorizations: [
              ...MunicipalityAuthorization,
              ...RegionAuthorization,
              ...ProvinceAuthorization,
              ...ForeignStateAuthorization,
              ...TerritoryAuthorization,
              ...ConsulateAuthorization,
            ],
            hidden: true,
          },
          {
            element: <NotFound />,
            path: '*',
            hidden: true,
          },
        ],
      },
    ],
  },
];

export const systemBreadcrumbs = [
  {
    path: '/',
    name: 'Home',
    element: <Nocp />,
    children: systemRoutes,
  },
];
